var map = {
	"./Array_logo.png": "e51b",
	"./Ascot_logo.png": "a09d",
	"./Assurex_logo.png": "5786",
	"./Bolt_logo.png": "f428",
	"./CNA_logo.png": "d1fd",
	"./Erwin_logo.png": "26a6",
	"./FRISS_logo.png": "6523",
	"./Grange_logo.png": "92ff",
	"./Hanover_logo.png": "7684",
	"./Kinsale_logo.png": "0b33",
	"./Lancer_logo.png": "c856",
	"./State Auto_logo.png": "cd45",
	"./Stolly_logo.png": "542d",
	"./Terrene_logo.png": "4823",
	"./USI_logo.png": "959a",
	"./West Bend_logo.png": "b39e",
	"./Westfield_logo.png": "87a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "625d3";